module.exports = __webpack_public_path__ + "img/clock-regular.11b69dd9.svg";